export default "__VITE_ASSET__boLmk964__"